import React, { useEffect, useState } from "react";
import { auth, db, googleProvider } from "../../firebase";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";
import "./Login.css";

const images = [
  "/images/3.jpeg",
  "/images/4.jpeg",
];

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [bgIndex, setBgIndex] = useState(0);

  const navigate = useNavigate();

  /* 🔁 Auto image change every 10 seconds */
  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % images.length);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      const docRef = doc(db, "users", userCredential.user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const { role } = docSnap.data();
        navigate(
          role === "organizer"
            ? "/organizer/dashboard"
            : "/member/dashboard"
        );
      } else {
        setError("No role found. Please contact support.");
      }
    } catch {
      setError("Invalid email or password");
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        await setDoc(docRef, { email: user.email, role: null });
        navigate("/select-role");
      } else {
        const { role } = docSnap.data();
        navigate(
          role === "organizer"
            ? "/organizer/dashboard"
            : "/member/dashboard"
        );
      }
    } catch {
      setError("Google Sign-In failed");
    }
  };

  return (
    <div className="login-container">
      {/* LEFT PANEL */}
      <div
        className="login-left"
        style={{ backgroundImage: `url(${images[bgIndex]})` }}
      >
        
      </div>

      {/* RIGHT PANEL */}
      <div className="login-right">
        <div className="login-box">
          <h2>Welcome Back</h2>

          <form onSubmit={handleLogin}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button className="login-btn">Login</button>
          </form>

          <div className="divider">OR</div>

          <button className="google-btn" onClick={handleGoogleLogin}>
            <img
              src="/images/google.webp"
              alt="Google"
              className="google-icon"
            />
            Continue with Google
          </button>

          {error && <p className="error-text">{error}</p>}

          <p className="signup-text">
            Don’t have an account? <Link to="/signup">Sign up</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
